import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78d52e3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 星汉未来开源社区招募 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(" 致力于让计算像电一样随需使用，星汉未来开源社区是一个关于云原生算力治理的开放社区。"),
          _hoisted_3,
          _createTextVNode(" 我们期待更多热衷于技术社区、有技术能力、乐于分享的伙伴们，与星汉未来共建云原生算力治理社区生态。 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_space, {
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$Store.Page().openModal('modalQR','openSource')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 立即加入 ")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_1",
            target: "_blank",
            href: $data.href.github
          }, {
            default: _withCtx(() => [
              _createTextVNode(" GitHub ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["href"]),
          _createCommentVNode("<a-button type=\"link\" class=\"button_n_1\""),
          _createCommentVNode("          target=\"_blank\" :href=\"href.document\">"),
          _createCommentVNode("    开发者文档"),
          _createCommentVNode("</a-button>")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    ])
  ]))
}